// src/components/Dispatchdetails/NombreReceptorForm.jsx
import React, { useState, useMemo } from "react";
import { Box, Button, TextField, Typography, Chip, Stack } from "@mui/material";
import { collection, doc, updateDoc } from "firebase/firestore";
import { useDispatch } from "react-redux";
import { db } from "../../firebase";
import { registrarCambioEnOrden } from "../../redux/accionsRegister";

const NombreReceptorForm = ({
  orderDetails,
  orderID,
  usuarioStorage,
  setOrderDetails,
}) => {
  const dispatch = useDispatch();
  const [userNameReceptor, setUserNameReceptor] = useState("");
  const [hasTypedName, setHasTypedName] = useState(false);

  const collectionRef = collection(
    db,
    `${process.env.REACT_APP_COL_USERS_ORDERS}`
  );

  const currentName =
    orderDetails?.userNameReceptor || orderDetails?.deliveryReceptor || "";

  const nextSanitized = useMemo(() => {
    const raw = (userNameReceptor || "").trim();
    return raw
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s]/gi, "");
  }, [userNameReceptor]);

  const canSave =
    hasTypedName &&
    nextSanitized.length > 0 &&
    nextSanitized.toLowerCase() !== currentName.trim().toLowerCase();

  const guardarUserNameReceptor = async (e) => {
    e.preventDefault();
    if (!canSave || !orderID) return;

    const data = {
      date: new Date(),
      lastValue: currentName,
      newValue: nextSanitized,
      orderId: orderID,
      type: "infoAdd",
      userId: usuarioStorage.uid,
      var: "userNameReceptor",
    };
    dispatch(registrarCambioEnOrden(data));

    const orderRef = doc(collectionRef, `${orderID}`);
    try {
      await updateDoc(orderRef, { userNameReceptor: nextSanitized });
      setOrderDetails((prev) => ({
        ...(prev || {}),
        userNameReceptor: nextSanitized,
      }));
      setUserNameReceptor("");
      setHasTypedName(false);
    } catch (error) {
      console.log("Error guardando userNameReceptor", error);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={guardarUserNameReceptor}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        mt: 1,
        width: "100%",
      }}
    >
      {/* Título + estado actual */}
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="space-between"
        useFlexGap
        flexWrap="wrap"
      >
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mr: 1 }}>
          Nombre del Receptor
        </Typography>
        {currentName ? (
          <Chip
            size="small"
            color="primary"
            variant="outlined"
            label={`Actual: ${currentName}`}
          />
        ) : (
          <Chip size="small" color="warning" label="Sin nombre registrado" />
        )}
      </Stack>

      {/* Campo + Botón responsivos con mínimos */}
      <Stack
        direction={{ xs: "column", md: "row" }} // ⬅️ apila hasta md, fila en >= md
        spacing={1.25}
        alignItems={{ xs: "stretch", md: "center" }}
        sx={{
          width: "100%",
          flexWrap: "nowrap", // evita saltos raros: cambiamos layout por breakpoint
        }}
      >
        <TextField
          fullWidth
          value={userNameReceptor}
          onChange={(e) => {
            setUserNameReceptor(e.target.value);
            setHasTypedName(true);
          }}
          placeholder="Ingrese nombre del receptor"
          variant="outlined"
          inputProps={{
            "aria-label": "Nombre del receptor",
            autoCapitalize: "words",
            autoComplete: "name",
          }}
          helperText={
            !hasTypedName
              ? "Escribe el nombre del receptor"
              : !canSave
              ? "Debe ser distinto al actual y no estar vacío"
              : "Listo para guardar"
          }
          sx={{
            minWidth: { md: 280 }, // ⬅️ mínimo en pantallas grandes
          }}
        />

        <Button
          variant="contained"
          type="submit"
          disabled={!canSave}
          sx={{
            backgroundColor: "#591E8F",
            color: "#fff",
            px: 2,
            height: { xs: "44px", md: "56px" }, // ⬅️ iguala altura al TextField
            width: { xs: "100%", md: "auto" }, // ⬅️ full en móvil, auto en >= md
            minWidth: { md: 160 }, // ⬅️ mínimo en pantallas grandes
            whiteSpace: "nowrap",
            "&:hover": { backgroundColor: "#25b2f4", color: "#591e8f" },
          }}
        >
          Guardar nombre
        </Button>
      </Stack>
    </Box>
  );
};

export default NombreReceptorForm;
